import React from 'react';
import { Card, CardHeader, CardContent, Typography } from '@mui/material';
import { Chat } from '@mui/icons-material';
import EngagementBySubjectChart from '../charts/EngagementBySubjectChart';
import Grid from '@mui/material/Grid';
import RichTooltip from '../../RichTooltip';
import { useTheme } from '@mui/material/styles';
import RenderPeriodDateRange from '../../account/reportingPeriod/RenderPeriodDateRange';
import { removeStopwords } from 'stopword';

const getTopWords = (array, max) => {
    const wordCount = array.reduce((acc, word) => {
        acc[word] = (acc[word] || 0) + 1;
        return acc;
    }, {});

    return Object.entries(wordCount)
        .sort((a, b) => b[1] - a[1])
        .slice(0, max)
        .map(([word, count]) => ({ name: word, value: count }));
};

const BuildData = emails => {
    if (!emails || emails.length === 0) {
        return null;
    }

    const maxEmails = emails.length < 10 ? emails.length : 10;

    const topEmails = emails.sort((a, b) => b.openRate - a.openRate).slice(0, maxEmails);

    let allWords = [];

    // lowercase each subject, replace any special chars with space, split string and remove empties, then push to array
    topEmails.map(e => e.subject
        .toLowerCase()
        .replace(/[^a-z]/g, ' ')
        .split(' ')
        .filter(Boolean)
        .map(word => allWords.push(word))
    );

    // remove excluded words
    const words = removeStopwords(allWords);

    const maxWords = words.length < 10 ? words.length: 10;

    // return top 10 words by count
    const topWords = getTopWords(words, maxWords);

    return topWords;
};

const EngagementBySubjectContentCard = ({ a, b, aColour, bColour, selectedPeriods }) => {
    const theme = useTheme();
    const aData = BuildData(a.emails);
    const bData = b ? BuildData(b.emails) : null;

    return (
        <Card sx={{ height: '100%', m: 0, p: 0 }}>
            <CardHeader
                sx={{
                    m: 0,
                    py: 1
                }}
                title="Engagement by Subject Content"
                slotProps={{
                    title: {
                        variant: 'h6',
                        fontWeight: 'normal'
                    }
                }}
                avatar={<Chat />}
                action={(
                    <RichTooltip>
                        <Typography variant="body1" sx={{ pb: 0.5 }}>The Top 10 most-used words in the Subject Lines of the Top 10 Emails by Total Open Rate</Typography>
                        <Typography variant="body2" color={theme.palette.text.secondary}>Common words (like 'it' and 'the') have been removed from results</Typography>
                    </RichTooltip>
                )}
            />
            <CardContent
                sx={{
                    m: 0,
                    px: 2,
                    py: 0,
                    textAlign: 'center'
                }}
            >
                {b ? (
                    <Grid container spacing={2}>
                        <Grid
                            sx={{ textAlign: 'center' }}
                            size={{ xs: 12, md: 6 }}
                        >
                            <Typography variant="caption" color={theme.palette.text.secondary}>Period A:</Typography>
                            <EngagementBySubjectChart
                                data={aData}
                                colour={aColour}
                            />
                        </Grid>
                        <Grid
                            sx={{ textAlign: 'center' }}
                            size={{ xs: 12, md: 6 }}
                        >
                            <Typography variant="caption" color={theme.palette.text.secondary}>Period B:</Typography>
                            <EngagementBySubjectChart
                                data={bData}
                                colour={bColour}
                            />
                        </Grid>
                    </Grid>
                ) : (
                    <>
                        <Typography variant="caption" color={theme.palette.text.secondary}>
                            <RenderPeriodDateRange
                                period={selectedPeriods ? selectedPeriods[0] : null}
                            />
                        </Typography>
                        <EngagementBySubjectChart
                            data={aData}
                            colour={aColour}
                        />
                    </>
                )}
            </CardContent>
        </Card>
    );
};

export default EngagementBySubjectContentCard;